import { render } from "./FirmwareManagement2023.vue?vue&type=template&id=565d072c&scoped=true"
import script from "./FirmwareManagement2023.vue?vue&type=script&lang=js"
export * from "./FirmwareManagement2023.vue?vue&type=script&lang=js"

import "./FirmwareManagement2023.vue?vue&type=style&index=0&id=565d072c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565d072c"],['__file',"src/views/ProductManage/FirmwareManagement2023/FirmwareManagement2023.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "565d072c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('565d072c', __exports__)) {
    api.reload('565d072c', __exports__)
  }
  
  module.hot.accept("./FirmwareManagement2023.vue?vue&type=template&id=565d072c&scoped=true", () => {
    api.rerender('565d072c', render)
  })

}


export default __exports__